/**
 * @generated SignedSource<<dc3e7531cb87b294ae5e21cdfeb80de3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryReview_shipmentQuote$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_shipmentQuote">;
  readonly " $fragmentType": "CheckoutDeliveryReview_shipmentQuote";
};
export type CheckoutDeliveryReview_shipmentQuote$key = {
  readonly " $data"?: CheckoutDeliveryReview_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryReview_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryReview_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "db6730afa025a001feb0d47493087dbc";

export default node;
